import type { ParsedCartItem } from 'ui/types/cartTypes';
import {
  ANNUAL_MEMBERSHIP_KEY,
  TWENTYFOUR_MONTH_MEMBERSHIP_KEY,
} from 'ui/utils/constants/membershipConstants';

export const getIsValidGiftMembership = (
  membershipInCart?: ParsedCartItem,
): boolean => {
  if (!membershipInCart) return false;
  const validGiftMemberships = [
    ANNUAL_MEMBERSHIP_KEY,
    TWENTYFOUR_MONTH_MEMBERSHIP_KEY,
  ];
  return validGiftMemberships.includes(membershipInCart?.key);
};
